import { AuthContextType } from '@auth/AuthProvider';
import NetworkController, { HTTPMethod, HTTPRequest, HTTPResponse } from '@data/controller/NetworkController';
import { PeopleSearchResult, Person } from '@interfaces/person.interface';

export type PeopleSearchField = 'email' | 'name';

export default class PeopleController {
  private static baseURL: string = process.env.REACT_APP_SANCTUARY_API_URL || "";

  // Pages are cursored: pass the previous page's nextLastPersonID to continue.
  static async fetchPeople(
    churchID: string,
    auth: AuthContextType,
    lastPersonID?: string | null
  ): Promise<HTTPResponse<PeopleSearchResult>> {
    const query = lastPersonID ? `?lastPersonID=${encodeURIComponent(lastPersonID)}` : '';

    return await NetworkController.performRequestAt<PeopleSearchResult>(
      this.baseURL,
      new HTTPRequest(HTTPMethod.GET, `/v1/church/${churchID}/people${query}`),
      auth.consumeRefreshToken
    );
  }

  // Scaffolding: the single-person endpoint isn't defined yet, so this path is
  // a placeholder and the envelope is read defensively by personFromResponse.
  static async fetchPerson(
    churchID: string,
    personID: string,
    auth: AuthContextType
  ): Promise<HTTPResponse<{ result: Person | null }>> {
    return await NetworkController.performRequestAt<{ result: Person | null }>(
      this.baseURL,
      new HTTPRequest(HTTPMethod.GET, `/v1/church/${churchID}/people/${personID}`),
      auth.consumeRefreshToken
    );
  }

  static async searchPeople(
    churchID: string,
    auth: AuthContextType,
    field: PeopleSearchField,
    query: string,
    lastPersonID?: string | null
  ): Promise<HTTPResponse<PeopleSearchResult>> {
    const cursor = lastPersonID ? `&lastPersonID=${encodeURIComponent(lastPersonID)}` : '';

    return await NetworkController.performRequestAt<PeopleSearchResult>(
      this.baseURL,
      new HTTPRequest(
        HTTPMethod.GET,
        `/v1/search/church/${churchID}/people/${field}?query=${encodeURIComponent(query)}${cursor}`
      ),
      auth.consumeRefreshToken
    );
  }
}
